import React, { useEffect } from 'react'
import { Outlet } from 'react-router';

import Header from "../owner/Header";
import Sidebar from "./Sidebar";
import { useSelector, useDispatch } from 'react-redux'

import { SET_ACCOUNT } from 'store/account/action'
import { httpOk, GET } from 'helpers/api'

function Layout() {
	const layoutSelector = useSelector(state => state.layout)
	const reduxAccount = useSelector(state => state.account)
	const dispatch = useDispatch()

	/**
	 * Права приезжают при входе и лежат в браузере до следующего. Пока админ был один,
	 * это не мешало; теперь доступы правят на ходу, и сотрудник, которому только что
	 * выдали раздел, видел старое меню, пока не перезайдёт. Спрашиваем актуальный
	 * список при открытии админки — обновление вкладки применяет изменения.
	 */
	useEffect(() => {
		async function refreshPermissions() {
			const response = await GET('/users/permissions', {}, { notification: false })

			if (httpOk(response)) {
				dispatch(SET_ACCOUNT({ ...reduxAccount, permissions: response.data }))
			}
		}

		refreshPermissions()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<div id="layout-wrapper">
			<Header />
			<Sidebar />
			<div className={"main-content " + (layoutSelector.showleftMenu ? 'sidebar-active-margin' : 'sidebar-margin')}>
				<div className="page-content">
					<Outlet />
				</div>
			</div>
		</div>
	)
}

export default Layout
